import { render, staticRenderFns } from "./ProductViewList.vue?vue&type=template&id=64b42442&"
import script from "./ProductViewList.vue?vue&type=script&lang=js&"
export * from "./ProductViewList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports